 const BASE_URL = "https://control.kklabsglobal.com/node_api/"
// const BASE_URL = "http://127.0.0.1:5000/";
// const BASE_URL = "https://api.wappss.com/";
// const BASE_URL = "https://api.wappss.com/";
// const BASE_URL = "https://api.infinitemlmsoftware.com/";
// const BASE_URL = "http://162.19.146.132:1398/node_api";
// const BASE_URL = "https://admin.bader.infiniteerp.in/node_api/"
// const BASE_URL = "http://192.168.6.37:8000/node_api/"

const DEFAULT_KEY = '14959'


const PAYPAL_CLIENT_ID = "Ad077-Gx8stGcfWQYawBiQUc4UbKWIRIg_PK4lHL4pzHR-uOPMz2vCk_jQ8QU9pcEw0j8U3UYDrEUS75"

export { BASE_URL, DEFAULT_KEY, PAYPAL_CLIENT_ID }
                                                                                                                    